import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { CategorizationScheme } from '@aptitude/shared-vanilla';
import { Observable, of, throwError } from 'rxjs';
import { catchError, switchMap, take } from 'rxjs/operators';
import { ContractGraphqlService } from '../../api/graphql/contract/contract-graphql.service';
import { CategorizationSchemesService } from '../../services/categorization-schemes.service';
import { CurrentUserService } from '../../services/current-user.service';
import { FeatureListService } from '../../services/feature-list.service';
import { GlobalNavigationService } from '../../services/global-navigation.service';
import { noDefaultErrorHandler } from '../../services/interceptors';

export const categorizationSchemesResolver: ResolveFn<
  CategorizationScheme[]
> = (): Observable<CategorizationScheme[]> => {
  const contractGraphqlService = inject(ContractGraphqlService);
  const featureListService = inject(FeatureListService);
  const categorizationSchemesService = inject(CategorizationSchemesService);
  const globalNavigationService = inject(GlobalNavigationService);
  const currentUserService = inject(CurrentUserService);

  return currentUserService.aptitudeUser$.pipe(
    switchMap((user) => {
      return featureListService.aptitudeFeatureList$.pipe(
        switchMap((features) => {
          const useNewPscLabel = features?.PSC_REBRANDING_PTHLA_1056838;

          return contractGraphqlService
            .getContractCategorizationSchemes(useNewPscLabel)
            .pipe(
              switchMap((categorizationSchemes) => {
                categorizationSchemesService.setCategorizationSchemes(
                  categorizationSchemes,
                );
                return of(categorizationSchemes);
              }),
              noDefaultErrorHandler(),
              catchError((err) => {
                globalNavigationService.goHome();
                return throwError(() => err);
              }),
              take(1),
            );
        }),
        take(1),
      );
    }),
  );
};
